import { formatHelper } from "../../common/helpers";
export const selectTopCustomersChartData = (state, compare) => {
    let { topCustomers, topCustomersCompare } = state.dashboard.topCustomerList;

    if (compare) {
        topCustomers = topCustomersCompare;
    }
    var data = {
        labels: [],
        data: []
    };

    if (!topCustomers || topCustomers.length == 0) return data;

    const max = topCustomers.length > 5 ? 5 : topCustomers.length;

    for (let i = 0; i < max; i++) {
        const customer = topCustomers[i];

        data.labels.push(customer.name);
        data.data.push(formatHelper.toTwoDecimal(customer.totalbought));
    }

    return data;
};
export const selectTopEmployeesData = state => {
    const { sellsTopEmployees } = state.dashboard.sellsTopEmployeesList;

    var data = {
        labels: [],
        data: []
    };

    if (!sellsTopEmployees || sellsTopEmployees.length == 0) return data;

    for (let i = 0; i < sellsTopEmployees.length; i++) {
        const employee = sellsTopEmployees[i];
        data.labels.push(`${employee.name} ${employee.lastname}`);
        data.data.push(formatHelper.toTwoDecimal(employee.totalSold));
    }
    return data;
};

export const selectStoreVisitorData = state => {
    const { storeVisitors } = state.dashboard.storeVisitorList;

    var data = {
        labels: [],
        data: []
    };

    if (!storeVisitors || storeVisitors.length == 0) return data;

    const max = storeVisitors.length > 3 ? 3 : storeVisitors.length;

    for (let i = 0; i < max; i++) {
        const store = storeVisitors[i];

        data.labels.push(`${store.name}`);
        data.data.push(store.visitors);
    }

    return data;
};

export const selectAverageTicketData = state => {
    const { averageTicket } = state.dashboard.averageTicketList;

    var data = {
        labels: [],
        data: []
    };

    if (!averageTicket || averageTicket.length == 0) return data;

    const max = averageTicket.length > 4 ? 4 : averageTicket.length;

    for (let i = 0; i < max; i++) {
        const ticket = averageTicket[i];

        data.labels.push(ticket.name);
        data.data.push(formatHelper.toTwoDecimal(ticket.average_ticket));
    }
    return data;
};



// WEBPACK FOOTER //
// ./src/store/dashboard/selector.js